"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDrawerOpener = exports.MobileDrawer = exports.DesktopDrawer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const drawer_1 = __importDefault(require("@kyruus/drawer"));
const CommonDrawerStyles = (props) => `
  & .MuiDrawer-paper {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: space-between;
    background-color: ${(0, ui_theme_1.fromTheme)('color_background_secondary')(props)};
    @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')(props)}) {
      flex-flow: row nowrap;
    }
  }
`;
exports.DesktopDrawer = (0, styled_1.default)(drawer_1.default) `
  display: none;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: block;
  }
  ${CommonDrawerStyles};
  & .MuiDrawer-paper {
    padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.MobileDrawer = (0, styled_1.default)(drawer_1.default) `
  display: block;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: none;
  }
  ${CommonDrawerStyles};
  & .MuiDrawer-paper {
    height: 100%;
    max-height: 75%;
    padding: 0;
    & > div {
      padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
      & > span {
        z-index: 2;
      }
    }
  }
`;
exports.MobileDrawerOpener = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  flex: 0 1 auto;
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: none;
  }
`;
//# sourceMappingURL=SmartDrawer.styles.js.map